import BaseModelTransfer from "@/models/BaseModelTransfer.js";

export const GridConfig = {
	list: BaseModelTransfer.list,
	columns: BaseModelTransfer.columns,
	query: {
		batchQuery:true,
        filter : function(o){
            return o.WorkflowStatus == 'Pending' || o.WorkflowStatus == 'Processing' || o.WorkflowStatus == 'Error'
        },
		limit: 5000
	},
	grid: {
		gridId: "TransferGrid",
		height: 500,
		checkbox: true,
		document: true,
		groupable: true,
		edit: true,
		delete: true,
		actionsColumnWidth: 110
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnApproveTransfer",
			type: "button",
			text: "Approve Transfer",
			showIcon: "toolbar",
			icon: "check-circle",
			attributes: {
				"class": " btn btn-primary float-right-btn"
			}
		},
		{
			id: "btnTransfer",
			type: "button",
			text: "Add Transfer",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": " btn btn-secondary float-right-btn"
			}
		},
		{
			id: "btnBulkImportTransfer",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: {
				"class": "float-right-btn btn btn-tertiary"
			},
		},
		{
			id: "btnBulkAttachment",
			type: "button",
			text: "Attach Documents",
			showIcon: "toolbar",
			icon: "attachment",
			attributes: {
				"class": "float-right-btn btn btn-light",
				"style": "background: #fff;"
			}
		}
	]

}

export const TransferApproveConfig = {
	list: "Transfer",
	columns: {
		Id: {
			dataName: "Id",
			type: "number"
		},
		Status: {
			dataName: "Status",
			type: "string"
		}
	}
};